import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

export default InjectedStyledComponent('span', 'selectionWizard', ['navigatorItemChevron']);